module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-1022w.6dae4735.jpg";